import { ContainerWrapper } from './Container.styled';

const Container = ({ children }) => (
  <ContainerWrapper>{children}</ContainerWrapper>
);

export default Container;
